/**
 * DropRedirect
 *
 * Redirects /drops/:slug to the collection page.
 * Keeps the route alive so old links/bookmarks still work.
 */

import React, { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { getDrop } from '../api/drops';
import { captureMintReferral } from '../utils/mint-referral';

export const DropRedirect: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!slug) {
      navigate('/drops', { replace: true });
      return;
    }

    getDrop(slug)
      .then((data) => {
        // Capture mint referral code before redirect (cookie persists across redirect)
        const mrefCode = searchParams.get('mref');
        if (mrefCode && data.drop.id) {
          captureMintReferral(data.drop.id, mrefCode);
        }

        if (data.drop.collection_slug) {
          navigate(`/collections/${data.drop.collection_slug}`, { replace: true });
        } else {
          navigate('/drops', { replace: true });
        }
      })
      .catch(() => {
        navigate('/drops', { replace: true });
      });
  }, [slug, navigate, searchParams]);

  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="w-6 h-6 border-2 border-brand-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
};

export default DropRedirect;
